import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  backgroundGray,
  black,
  imac13inMax,
  iphone5Max,
  marketingMobileCuttoff
} from "@css/constants";
import {backgroundImageStyle, fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";

export const CarrierSectionContainer = styled.div<CarrierSectionContainerProps>`
  flex-direction: column;
  display: flex;
  background-color: ${backgroundGray};

  @media(max-width: ${marketingMobileCuttoff}) {
    display: ${props => props.imageUrlMobile ? 'flex' : 'none'};
    margin-top: 20px;
  }
`;

type CarrierSectionImageProps = {
  imageUrl: string;
  imageHeight: string;
  imageUrlMobile: string;
  imageHeightMobile: string;
}

type CarrierSectionContainerProps = Pick<CarrierSectionImageProps, 'imageUrlMobile'>;
type CarrierSectionTopTextProps = {
  bottomText: string;
  isFeatured: boolean;
  topTextSize?: number;
};

export const CarrierSectionImage = styled.div<CarrierSectionImageProps>`
  flex-direction: column;
  display: flex;
  height: ${props => props.imageHeight};
  background-image: url(${props => props.imageUrl});
  align-self: center;
  ${backgroundImageStyle};
  width: 100%;
  
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${imac13inMax}) {
    width: 90%;
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    background-image: url(${props => props.imageUrlMobile});
    height: ${props => props.imageHeightMobile};
    padding-left: 0;
    width: 90%;
  }
`;


export const CarrierSectionTopText = styled.div<CarrierSectionTopTextProps>`
  ${props => props.bottomText || props.isFeatured ? fontSize(16) : fontSize(props.topTextSize ? props.topTextSize : 32)};
  color: ${black};
  ${FontNormal(600)};
  align-self: center;
  text-align: center;
  margin-top: 25px;
  margin-bottom: 15px;
  width: ${props => props.bottomText ? '100%' : '42%'};
  ${props => props.topTextSize ? `max-width: 500px;` : ''};
  
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${imac13inMax}) {
    width: ${props => props.bottomText ? '90%' : '62%'};;
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    padding-left: 0;
    width: 90%;
    ${props => props.bottomText ? fontSize(16) : fontSize(24)};
  }

  @media(max-width: ${iphone5Max}) {
    ${fontSize(14)}
  }

  sup {
    font-size: 10px;
  }
`;

export const CarrierSectionBottomText = styled('div')(css`
  ${fontSize(16)};
  ${FontNormal(400)};
  color: ${black};
  font-style: italic;
  align-self: center;
  text-align: center;
  margin-bottom: 16px;
  margin-top: 15px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(12)};
    padding-left: 0;
    width: 90%;
  }
`)
